<template>
    <div class="widget">
        <ToastContainer />
    </div>
</template>
